import {createSlice, createAsyncThunk} from '@reduxjs/toolkit';
import ProviderManager from '../../../provider/providerManager';
import {validateFields, validateField} from '../../../utilities/validation/validator';
import lodash from 'lodash';

export const doCallBackLite = createAsyncThunk('callBackLite/doCallBackLite', async (data, thunkAPI) => {
  try {
    const result = await ProviderManager.getProviderData('doCallBack', [data.idNumber, data.phoneNumber, data.subjectCode]);
    return result.Body.isSuccess;
  } catch (error) {
    return error;
  }
});

const initialState = {
  form: {
    phone: '',
    valid: '',
    errors: {
      phone: '',
    },
    rules: {},
  },
  success: false,
  isCallBackError: false,
  isCallbackExist: false,
};

const callBackLiteSlice = createSlice({
  name: 'callBackLite',
  initialState: initialState,

  reducers: {
    clearAll: {
      reducer(state, action) {
        state.success = false;
        state.isCallBackError = false;
        state.isCallbackExist = false;
        state.form.valid = '';
      },
    },
    validateHandler: {
      reducer(state, action) {
        state.form = action.payload;
      },
      prepare(payload) {
        const validate = validateFields(lodash.cloneDeep(payload));
        return {payload: validate};
      },
    },
    changeHandler: {
      reducer(state, action) {
        state.form = action.payload;
      },
      prepare(payload) {
        const name = payload.target.name;
        const value = payload.target.value;
        const form = lodash.cloneDeep(payload.form);
        const validate = validateField(form, name, value);
        return {payload: validate};
      },
    },
  },
  extraReducers: {
    [doCallBackLite.fulfilled]: (state, action) => {
      if (action.payload) {
        if (action.payload.errorCode == '3') {
          state.isCallbackExist = true;
        } else {
          state.success = true;
          state.isCallBackError = false;
        }
      } else {
        state.success = false;
        state.isCallBackError = true;
      }
    },
  },
});

export const {validateHandler, changeHandler, clearAll} = callBackLiteSlice.actions;

export default callBackLiteSlice.reducer;
